import React, { useContext, useState } from 'react';
import Progress from './Progress';
import AcademicInfo from './AcademicInfo';
import EmploymentInfo from './EmploymentInfo';
import TermsAndCondition from './Terms&conditions';
import AdmissionForm from './AdmissionForm';
import RegisterInfo from './RegisterInfo';
import { FormContext } from './Provider';

export default function MultiStepForm() {
    const [step, setStep] = useState(0);
     const { Auth } = useContext(FormContext)

    const renderStepComponent = () => {
        switch (step) {
            case 0: return <AdmissionForm step={step} setStep={setStep} />;
            case 1: return <AcademicInfo step={step} setStep={setStep} />;
            case 2: return <EmploymentInfo step={step} setStep={setStep} />;
            case 3: return <RegisterInfo step={step} setStep={setStep} />;
            case 4: return <TermsAndCondition step={step} setStep={setStep} />;
            default: return null;
        }
    };
    console.log("step:", step); // Debug line
    return (
        <div className='flex flex-col sm:flex-col items-start justify-center  sm:block'>
            <div className="w-full md:max-w-7xl mx-auto">
                <Progress step={step} Auth={Auth } />

            </div>
            <div className="mt-3">
                {renderStepComponent()}
            </div>
        </div>
    );
}
